import { render } from "./InterfaceIntegratedEditor.vue?vue&type=template&id=1f177626&scoped=true"
import script from "./InterfaceIntegratedEditor.vue?vue&type=script&lang=js"
export * from "./InterfaceIntegratedEditor.vue?vue&type=script&lang=js"

import "./InterfaceIntegratedEditor.vue?vue&type=style&index=0&id=1f177626&scoped=true&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f177626"]])

export default __exports__